import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import authActions from './auth.actions'


const resetAll = (): ThunkAction<Promise<void>, any, any, any> => {
  return async (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch(authActions.reset())
  };
}


const actions = {
  resetAll
}

export default actions
